import React, { CSSProperties } from 'react';

interface SchoolDistrictsProps {
  detailListStyle: CSSProperties,
  elementary: string | undefined,
  middle: string | undefined,
  high: string | undefined,
}

const SchoolDistricts = ({detailListStyle, elementary, middle, high} : SchoolDistrictsProps) => {
	return (
		<React.Fragment>
			<p className="text-uppercase cc-font-weight--bold mb-1">
				<i className="fal fa-school me-2" />
        School Districts
			</p>
			<ul style={detailListStyle}>
				{ (elementary || middle || high)
					? <React.Fragment>
						{elementary && <li><span className="cc-font-weight--normal">Elementary School:</span> {elementary}</li>}
						{middle && <li><span className="cc-font-weight--normal">Middle or Junior School:</span> {middle}</li>}
						{high && <li><span className="cc-font-weight--normal">High School:</span> {high}</li>}
					</React.Fragment>
					: <li>No school info listed</li>
				}
        
			</ul>
		</React.Fragment>
	);
};

export default SchoolDistricts;